// Some rich text editors return empty content as <p><br></p>
export const isRichTextContentEmpty = (content: string | undefined | null): boolean =>
  !content || content.length === 0 || content.replace(/(<p>|<br>|<\/p>)/g, '').length === 0;
